import { type Control, useFormContext, useWatch } from "react-hook-form";
import { useResourceFormContext as useFormFrameworkContext } from "src/components/Form/hooks/useResourceFormContext.ts";

import {
  getHiddenFieldConfig,
  getNamesToWatchForHiddenFields,
} from "src/components/Form/utils/hiddenFields.ts";

export const useIsRowHidden = ({
  names,
  control: controlProp,
}: {
  names: string[];
  control?: Control<any>;
}): {
  isHidden: Record<string, boolean>;
} => {
  const { control: controlFromContext, getValues } = useFormContext<any>();
  const { hidden_fields, fields } = useFormFrameworkContext();

  const control = controlProp ?? controlFromContext;

  const namesToWatch = getNamesToWatchForHiddenFields({
    getValues,
    hidden_fields,
    fields,
    names: names,
  });

  useWatch({
    // @ts-ignore
    name: namesToWatch,
    disabled: namesToWatch.length === 0,
    control,
  });

  const isHidden = names.reduce((acc, name) => {
    const hiddenField = getHiddenFieldConfig({
      name,
      hidden_fields,
      fields,
    });

    return {
      ...acc,
      [name]: hiddenField
        ? typeof hiddenField === "function"
          ? hiddenField(getValues())
          : typeof hiddenField === "boolean"
          ? hiddenField
          : hiddenField.hide_condition(getValues())
        : false,
    };
  }, {});

  return {
    isHidden,
  };
};
